// src/components/NotFound.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        color: 'text.primary',
        padding: 2,
      }}
    >
      <Typography variant="h3" gutterBottom>
        404 - Pagina Non Trovata
      </Typography>
      <Typography variant="h6" gutterBottom>
        Ci dispiace, la pagina che stai cercando non esiste.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<HomeIcon />}
        onClick={() => navigate('/dashboard')}
        sx={{
          mt: 3,
          borderRadius: '12px',
          textTransform: 'none',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 6,
          },
        }}
      >
        Torna alla Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
